import {
    BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate,
} from 'react-router-dom';
import {
    CssBaseline, Container, Typography, Tabs, Tab, Box,
} from '@mui/material';
import { useEffect, useState } from 'react';
import BusinessRoomsList from "./components/BusinessRoomsList";
import BusinessRoomDetail from "./components/BusinessRoomDetail";
import UserStats from "./components/UserStats";
import Notices from "./components/Notices";
import NoticeForm from "./components/NoticeForm";



const tabList = [
    { label: '방 목록', path: '/admin/business-rooms' },
    { label: '통계', path: '/admin/room-stats' },
    { label: '공지사항', path: '/admin/notices' },
];

function HeaderTabs() {
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = useState(0);

    useEffect(() => {
        const idx = tabList.findIndex(tab => location.pathname.startsWith(tab.path));
        setValue(idx !== -1 ? idx : 0);
    }, [location.pathname]);

    return (
        <Box mt={2} mb={3}>
            <Typography variant="h4" mb={2}>ROOMI 관리자</Typography>
            <Tabs value={value} onChange={(_, newValue) => navigate(tabList[newValue].path)}>
                {tabList.map((tab, idx) => (
                    <Tab key={idx} label={tab.label} />
                ))}
            </Tabs>
        </Box>
    );
}

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<Navigate to="/admin/room-stats" replace />} />
            <Route path="/admin/business-rooms" element={<BusinessRoomsList />} />
            <Route path="/admin/business-rooms/:roomId" element={<BusinessRoomDetail />} />
            <Route path="/admin/room-stats" element={<UserStats />} />
            <Route path="/admin/notices" element={<Notices />} />
            <Route path="/admin/notice/:id" element={<NoticeForm />} />
            <Route path="/admin/notice-form" element={<NoticeForm />} />
        </Routes>
    );
}

export default function App() {
    return (
        <>
            <CssBaseline />
            <BrowserRouter>
                <Container maxWidth="lg">
                    <HeaderTabs />
                    <AppRoutes />
                </Container>
            </BrowserRouter>
        </>
    );
}